import type { GetStaticProps, GetStaticPaths } from "next";
import Head from "next/head";
import { MDXRemote, MDXRemoteSerializeResult } from "next-mdx-remote";
import { serialize } from "next-mdx-remote/serialize";
import { getPostFromSlug, getSlugs, PostMeta } from "../../../lib/blogUtils";

interface MDXPost {
  source: MDXRemoteSerializeResult<Record<string, unknown>>;
  meta: PostMeta;
}

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = getSlugs().map((slug) => ({ params: { slug } }));
  return {
    paths,
    fallback: false,
  };
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const { slug } = params as { slug: string };
  const { content, meta } = getPostFromSlug(slug);
  const mdxSource = await serialize(content);

  return {
    props: {
      post: { source: mdxSource, meta },
      slug,
    }
  };
}

function StyledImage({ src, alt, ...props }: React.ImgHTMLAttributes<HTMLImageElement>) {
  return (
    <img
      src={src}
      alt={alt}
      className="mx-auto rounded-lg shadow-lg my-8 max-w-full h-auto"
      {...props}
    />
  );
}

const components = {
  img: StyledImage,
};

export default function PostPage({ post, slug }: { post: MDXPost; slug: string }) {
  return (
    <>
      <Head>
        <title>{post.meta.title}</title>
        <meta name="description" content={post.meta.description} />
        <meta property="og:title" content={post.meta.title} />
        <meta property="og:description" content={post.meta.description} />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={`https://claros.so/blog/posts/${slug}`} />
        <meta property="og:image" content="https://claros.so/another-preview.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={post.meta.title} />
        <meta name="twitter:description" content={post.meta.description} />
        <meta name="twitter:image" content="https://claros.so/another-preview.png" />
        <script
          dangerouslySetInnerHTML={{
            __html: `
              (()=>{!function(e){let{apiKey:o,iconColor:t,customSelector:i}=e;var n=[];publisherjs=function(){n.push(arguments)},console.log("PublisherJS script loading...");const s=(e=>{const o=(new Option).style;o.color=e;const t="#3a0ca3";return "" !==o.color?e:null})(t);var r=document.createElement("script");r.src="https://cdn.jsdelivr.net/gh/ioniccommerce/js-demo@main/publishers.min.js",r.async=!0,r.onload=function(){try{publisherjs=publisherjs(o,s,i),"complete"===document.readyState||"loaded"===document.readyState||"interactive"===document.readyState?(console.log("Document is already loaded. Initializing publisherjs..."),publisherjs("initializeReactWidgets")):(console.log("Document is not loaded yet. Initializing publisherjs on DOMContentLoaded..."),document.addEventListener("DOMContentLoaded",(()=>publisherjs("initializeReactWidgets")))),n.forEach((function(e){publisherjs(e[0],[...e].slice(1))}))}catch(e){console.error("Error initializing publisherjs:",e),window.dispatchEvent(new CustomEvent("publisherjs-error",{detail:e.message}))}},r.onerror=function(){const e="Failed to load the script: "+r.src;console.error(e),window.dispatchEvent(new CustomEvent("publisherjs-error",{detail:e}))},document.head.appendChild(r)}({
                apiKey:"UIN6SYVAS3P8VI",
                iconColor:"OPTIONAL_ICON_COLOR",
                customSelector: "a"
              })})();
            `,
          }}
        />

      </Head>

      <article className="mt-8 max-w-4xl mx-auto px-4 py-8 prose prose-lg prose-img:mx-auto prose-img:rounded-lg prose-img:shadow-lg prose-img:my-8">

        <MDXRemote {...post.source} components={components} />
{/*
          <script>
          (() => {
                !function(e) {
                  let { apiKey: o, iconColor: t, customSelector: i } = e;
                  var n = [];
                  publisherjs = function() { n.push(arguments) };
                  console.log("PublisherJS script loading...");
                  const s = (e => {
                    const o = (new Option).style;
                    o.color = e;
                    const t = "#3a0ca3";
                    return "" !== o.color ? e : null;
                  })(t);
                  var r = document.createElement("script");
                  r.src = "https://cdn.jsdelivr.net/gh/ioniccommerce/js-demo@main/publishers.min.js";
                  r.async = !0;
                  r.onload = function() {
                    try {
                      publisherjs = publisherjs(o, s, i),
                      "complete" === document.readyState || "loaded" === document.readyState || "interactive" === document.readyState ?
                      (console.log("Document is already loaded. Initializing publisherjs..."), publisherjs("initializeReactWidgets")) :
                      (console.log("Document is not loaded yet. Initializing publisherjs on DOMContentLoaded..."),
                      document.addEventListener("DOMContentLoaded", () => publisherjs("initializeReactWidgets"))),
                      n.forEach(function(e) { publisherjs(e[0], [...e].slice(1)) });
                    } catch(e) {
                      console.error("Error initializing publisherjs:", e);
                      window.dispatchEvent(new CustomEvent("publisherjs-error", { detail: e.message }));
                    }
                  };
                  r.onerror = function() {
                    const e = "Failed to load the script: " + r.src;
                    console.error(e);
                    window.dispatchEvent(new CustomEvent("publisherjs-error", { detail: e }));
                  };
                  document.head.appendChild(r);
                }({
                  apiKey: "UIN6SYVAS3P8VI",
                  iconColor: "OPTIONAL_ICON_COLOR",
                  customSelector: "a"
                })();
          </script> */}
      </article>
    </>
  );
}